import { AxiosPromise } from 'axios';
import http from './httpBase';
import { Configuration } from './types';
import { configurationMockData } from './mockData';

const { get, post, mock } = http;
export const CONFIGURATION_URL = '/configuration';

const getCurrentConfiguration = (): AxiosPromise<Configuration> =>
  get(`${CONFIGURATION_URL}`, {});

mock.onGet(CONFIGURATION_URL).reply(200, configurationMockData);

const updateConfiguration = (
  body: Configuration,
): AxiosPromise<Configuration> => post(`${CONFIGURATION_URL}`, body);

mock.onPost(CONFIGURATION_URL).reply(200, configurationMockData);

export default {
  getCurrentConfiguration,
  updateConfiguration,
};
